export default class Storage {
  get(name) {
    return localStorage.getItem(name);
  }

  set(name, value) {
    localStorage.setItem(name, value)
  }
}



// WEBPACK FOOTER //
// ./scripts/libs/Storage.js